import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";

import { grey } from "@mui/material/colors";
import React, { useContext } from "react";
import { FeaturedBots } from "../assets/data/FeaturedBots";
import { FeaturedPress, FeaturedTeam } from "../assets/data/FeturedTeam";
import { UserContext } from "../contexts/UserContext";

const i18n = {
  demoTitle:
    "BotFrens powers the Artbots network, the world's largest social museum, reaching over 50 million people every month.",
  mainDescrOne:
    "Use bots to share custom content on Bluesky, Discord, Farcaster, and X.",
  mainDescrTwo: "Works with NFTs from Arbitrum, Base, Ethereum, and Polygon.",
  mainDescrThree: "Automated posting using JSON, RSS, and more.",
  mainTitle: "No-Code Social Bots for Artists, Builders, and Creators",
  newsTitle: "News and Press",
  teamTitle: "Teams",
};

const Splash = () => {
  const { hasUser, showRegisterModal } = useContext(UserContext);

  const renderExamples = () => {
    return (
      <Box mt={10}>
        <Typography
          variant="h5"
          mb={9}
          sx={{
            color: grey[200],
            textAlign: "center",
            width: "80%",
            marginX: "auto",
          }}
        >
          {i18n.demoTitle}
        </Typography>

        <Stack direction="row" justifyContent="center" spacing={2}>
          {FeaturedBots.map(({ avatar, title, url, username }, idx) => {
            return (
              <Card
                key={idx}
                sx={{
                  cursor: "pointer",
                  width: 220,
                  display: {
                    xs: idx >= 3 ? "none" : "block",
                    md: "block",
                    lg: "block",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={avatar}
                  alt={username}
                  onClick={() => window.open(url, "_blank")}
                />
                <CardContent>
                  <Typography
                    sx={{ color: grey[400], textAlign: "center" }}
                    variant="body2"
                  >
                    {title}
                  </Typography>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      </Box>
    );
  };

  const renderTeam = () => {
    return (
      <Box my={10}>
        <Typography
          variant="h5"
          mb={9}
          sx={{ color: grey[200], textAlign: "center" }}
        >
          {i18n.teamTitle}
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={2}>
          {FeaturedTeam.map(
            ({ avatar, email, linkedin, name, title, twitter }, idx) => {
              return (
                <Card
                  sx={{
                    cursor: linkedin || twitter ? "pointer" : "default",
                    padding: 2,
                    width: 220,
                    display: {
                      xs: idx >= 3 ? "none" : "block",
                      md: "block",
                      lg: "block",
                    },
                  }}
                  key={idx}
                  onClick={() => {
                    if (linkedin) {
                      window.open(linkedin, "_blank");
                    } else if (twitter) {
                      window.open(twitter, "_blank");
                    }
                  }}
                >
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Avatar
                      alt={title}
                      src={avatar}
                      sx={{ width: 84, height: 84 }}
                    />
                    <Typography mt={2}>{name}</Typography>
                    <Typography sx={{ color: grey[600] }} variant="body2">
                      {title}
                    </Typography>
                  </Stack>
                </Card>
              );
            },
          )}
        </Stack>
      </Box>
    );
  };

  const renderPress = () => {
    return (
      <Box mt={10}>
        <Typography
          variant="h5"
          mb={9}
          sx={{ textAlign: "center", color: grey[200] }}
        >
          {i18n.newsTitle}
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={2}>
          {FeaturedPress.map(({ image, title, link, target }, idx) => {
            return (
              <Card
                sx={{
                  width: 220,
                  display: {
                    xs: idx >= 3 ? "none" : "block",
                    md: "block",
                    lg: "block",
                  },
                }}
                key={idx}
              >
                <CardActionArea onClick={() => window.open(link, target)}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={image}
                    alt={title}
                  />
                  <CardContent>
                    <Typography>{title}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            );
          })}
        </Stack>
      </Box>
    );
  };

  return (
    <Box>
      <Container
        maxWidth="false"
        sx={{
          pt: 16,
          backgroundColor: "#222222",
          background:
            "linear-gradient(0deg, rgba(10,10,10,1) 0%, rgba(34,34,34,1) 50%)",
        }}
      >
        <Container maxWidth="lg">
          <Stack alignItems="center">
            <Grid spacing={{ xs: 2, md: 4 }} container>
              <Grid
                item
                lg={4}
                md={4}
                sx={{
                  backgroundImage:
                    'url("https://cdn.botfrens.com/assets/botfren.svg")',
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  display: { xs: "none", md: "block", lg: "block" },
                }}
              ></Grid>
              <Grid item lg={8} md={8} sm={12} mb={3}>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 500, lineHeight: 1 }}
                  mb={8}
                  color={"#8B99D5"}
                >
                  {i18n.mainTitle}
                </Typography>

                <Typography variant="body1">{i18n.mainDescrOne}</Typography>

                <Stack
                  direction="column"
                  alignItems="flex-start"
                  color={grey[400]}
                  sx={{ mb: 2 }}
                >
                  <Typography variant="body1">{i18n.mainDescrTwo}</Typography>
                  <Typography variant="body1">{i18n.mainDescrThree}</Typography>
                </Stack>

                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                >
                  {!hasUser() && (
                    <Button
                      variant="contained"
                      onClick={() => showRegisterModal(true)}
                    >
                      Get started
                    </Button>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </Container>
      </Container>

      <Container>
        {renderExamples()}
        {renderPress()}
        {renderTeam()}
      </Container>
    </Box>
  );
};
export default Splash;
